import { createRouter, createWebHistory } from 'vue-router'
import CrlsView from "../views/CrlsView.vue";
import HistoryView from "../views/HistoryView.vue";

const routes = [
  {
    path: "/",
    name: "crls",
    component: CrlsView,
    props: { showExpired: false }
  },
  {
    path: "/expired",
    name: "expired",
    component: CrlsView,
    props: { showExpired: true }
  },
  {
    path: "/historico",
    name: "history",
    component: HistoryView
  }
];


const router = createRouter({
  history: createWebHistory(),
  base: process.env.BASE_URL,
  routes,
  // eslint-disable-next-line
  scrollBehavior(to, from, savedPosition) {
    console.log("scrollBehavior to: "+to.hash);
    if (to.hash) {
      // eslint-disable-next-line
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve({
            el: to.hash,
            behavior: 'smooth',
          })
        }, 500)
      })
    }
  }
})

export default router
